export default "__VITE_ASSET__ce4e6cc3__"